import React, { FC, ReactElement, MouseEvent } from 'react'
import { onKeyboardClick } from '@/utils/a11y/keyboard-click'

const SendRecieveIcon: FC<{
	className?: string
	width?: number
	height?: number
	onClick?: (evt: MouseEvent) => void
}> = (props): ReactElement => {
	return (
		<svg
			onClick={props.onClick}
			width={props.width}
			height={props.height}
			className={props.className}
			viewBox="0 0 17 20"
			fill="none"
			role={props.onClick ? "button" : undefined}
			tabIndex={props.onClick ? 0 : undefined}
			onKeyDown={onKeyboardClick(props.onClick)}
		>
			<path
				d="M0.26 4.5C-0.1 4.83 -0.08 5.33 0.26 5.64L4.8 9.91C4.96 10.06 5.19 10.15 5.38 10.15C5.85 10.15 6.17 9.84 6.17 9.4C6.17 9.19 6.09 9.02 5.94 8.87L4.04 7.11L2.41 5.75L4.44 5.83H16.21C16.67 5.83 16.99 5.52 16.99 5.07C16.99 4.63 16.67 4.32 16.21 4.32H4.44L2.41 4.39L4.04 3.04L5.94 1.27C6.09 1.13 6.17 0.97 6.17 0.75C6.17 0.3 5.85 0 5.38 0C5.19 0 4.96 0.08 4.8 0.24L0.26 4.5ZM16.74 15.5C17.09 15.17 17.08 14.67 16.74 14.35L12.2 10.08C12.04 9.94 11.81 9.85 11.61 9.85C11.14 9.85 10.84 10.15 10.84 10.59C10.84 10.81 10.91 10.98 11.06 11.12L12.96 12.89L14.6 14.25L12.56 14.17H0.79C0.33 14.17 4.13e-05 14.48 4.13e-05 14.92C4.13e-05 15.37 0.33 15.68 0.79 15.68H12.56L14.6 15.6L12.96 16.96L11.06 18.72C10.91 18.87 10.84 19.03 10.84 19.25C10.84 19.7 11.14 20 11.61 20C11.81 20 12.04 19.91 12.2 19.76L16.74 15.5Z"
				fill="#7F56D9"
			/>
		</svg>
	)
}

export default SendRecieveIcon
